<section class="sect-table" id="planes" appViewportEnterDirective (viewPortEntered)="activeRoute.setActiveRoute('home-plan')">
    <div class="container">
        <h2>Planes Simples y Transparentes</h2>
        <div class="planes">
        
            <div class="plan-card-container">
                <p><br></p>
                <div>
                    <div class="top t1">
                            <h3 >Plan Básico</h3>
                        </div>
                    <div class="plan-card">
                        <p class="price">$290.000 <small>/mes</small> </p>
                        <p class="description">Lo esencial para comenzar a automatizar tu administración.</p>
                        <ul>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Integración con <b>Whatsapp Business</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                            <p> Responde <b>consultas</b> de consorcistas.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Mantiene <b>información de consorcistas</b> al día.</p>
                            </li>
                        </ul>
                    </div>
                    <p class="bottom">Hasta 10 consorcios</p>
                </div>
            </div>

            <div class="plan-card-container marked">
                <p class="not-border" style="text-align: center;"><b>¡Más Elegido!</b></p>
                <div>
                    <div class="top t2">
                        <h3 >Plan Pro</h3>
                    </div>
                    <div class="plan-card t2">
                        <p class="price">$390.000 <small>/mes</small> </p>
                        <p class="description">Profesionalizá toda tu gestión con Inteligencia Artificial.</p>
                        <ul>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Todo lo del <b>Plan Básico</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Coordinación y seguimiento de <b>trabajos</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Resuelve <b>urgencias</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Control <b>preventivos*</b>.</p>
                            </li>
                        </ul>
                        <small>*Disponible para consorcios que abonan la digitalización de su estructura</small>
                    </div>
                    <p class="bottom t2">Hasta 20 consorcios</p>
                </div>
            </div>

            <div class="plan-card-container">
                <p class="not-border" style="text-align: center;"><b>¡Próximamente!</b></p>
                <div>
                    <div class="top t2">
                        <h3 >Plan Pro Plus</h3>
                    </div>
                    <div class="plan-card">
                        <p class="price">$690.000 <small>/mes</small> </p>
                        <p class="description">Llevá tu administración al siguiente nivel.</p>
                        <ul>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Todo lo del <b>Plan Pro</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Integración con <b>E-mail</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Recibe y ordena <b>comprobantes</b>.</p>
                            </li>
                            <li>
                                <img src="./assets/ok.svg" alt="">
                                <p> Aplica el <b>reglamento*</b>.</p>
                            </li>
                        </ul>
                        <small>*Disponible para consorcios que abonan la digitalización de su estructura</small>
                    </div>
                    <p class="bottom">Hasta 30 consorcios</p>
                </div>
            </div>

        </div>
        <div class="extra">
            <p>Sumá <b>10 consorcios extra</b> a tu plan por $50.000 adicionales por mes.</p>
        </div>
        <button class="compara" [class.active]="isTableActive" (click)="isTableActive=!isTableActive">
            <span>
                Compará los planes y elegí el que mejor se adapte a tus necesidades.
            </span>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.91003 19.9201L15.43 13.4001C16.2 12.6301 16.2 11.3701 15.43 10.6001L8.91003 4.08008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            
        </button>
        <div class="scroll" [class.active]="isTableActive">
            <table>
                <thead>
                    <tr class="table-decorator">
                        <th></th>
                        <th>¡Próximamente!</th>
                        <th>
                            Más Elegido 
                        </th>
                        <th></th>
                    </tr>
                    <tr class="label-table">
                        <th>Funcionalidades</th>
                        <th>Plan Pro Plus</th>
                        <th>Plan Pro</th>
                        <th>Plan Básico</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="tr-grey">
                        <td>Precio mensual:</td>
                        <td> $690.000</td>
                        <td>$390.000</td>
                        <td>$290.000</td>
                    </tr>
                    <tr>
                        <td>Implementación asistida</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                    </tr>
                    <tr>
                        <td>Integración con Whatsapp Business</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                    </tr>
                    <tr>
                        <td>Integración con E-Mail</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Responde consultas</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                    </tr>
                    <tr>
                        <td>Mantiene datos actualizados</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                    </tr>
                    <tr>
                        <td>Coordinación y Seguimiento de Trabajos</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Mantenimiento preventivo</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Resuelve urgencias</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Aplica el reglamento</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Recibe y ordena comprobantes</td>
                        <td><img src="./assets/ok.svg" alt=""></td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Cantidad de Consorcios</td>
                        <td>Hasta 30 <br /> consorcios</td>
                        <td>Hasta 20 <br /> consorcios</td>
                        <td>Hasta 10 <br /> consorcios</td>
                    </tr>   
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4">+ Sumá 10 consorcios por: $50.000</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="btn-cont">
            <a href="https://wa.me/5493417860632?text=Quiero saber más sobre AdminAI" target="_blank" class="button-primary">
                ¿Dudas? ¡Consultanos!
            </a>
        </div>
    </div>
    <!-- <img src="./assets/table-texture.png" class="texture" alt="textura de fondo"> -->
</section>